/* Folliva Clear · article reading: progress line + "In this article" contents (desktop: sticky at the left; phones: a box). */
(function () {
  var body = document.querySelector('[data-fc-art-body]'); if (!body) return;
  var bar = document.querySelector('[data-fc-art-progress]');
  function slug(t) { return (t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section'; }
  var hs = [].slice.call(body.querySelectorAll('h2')).filter(function (h) { return !h.closest('.fc-sources, .fc-artbox, .fc-takeaways'); });
  var used = {};
  hs.forEach(function (h) { if (!h.id) { var s = slug(h.textContent), id = s, n = 2; while (used[id] || document.getElementById(id)) id = s + '-' + n++; h.id = id; } used[h.id] = 1; });
  var nav = document.querySelector('[data-fc-toc]'), mob = document.querySelector('[data-fc-toc-m]');
  if (hs.length >= 3) {
    [nav, mob].forEach(function (box) {
      if (!box) return; var ol = box.querySelector('ol');
      hs.forEach(function (h) { var li = document.createElement('li'), a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); a.setAttribute('data-for', h.id); li.appendChild(a); ol.appendChild(li); });
      box.hidden = false;
    });
    if (mob) mob.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { mob.open = false; }); });
    if ('IntersectionObserver' in window && nav) {
      var links = nav.querySelectorAll('a'), cur = null;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) cur = e.target.id; });
        if (cur) links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('data-for') === cur); });
      }, { rootMargin: '-15% 0px -70% 0px' });
      hs.forEach(function (h) { io.observe(h); });
    }
  }
  if (bar) {
    var tick = false;
    function upd() {
      tick = false;
      var r = body.getBoundingClientRect(), h = r.height - window.innerHeight * .6;
      var p = h > 0 ? Math.min(1, Math.max(0, -r.top / h)) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }
})();
